import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnboardingData,
    setOnboardingData
} from '../../../../redux/onboardingSlice';
import { http_put } from '../../utils/api_client';

const OPTIONS = [
    'Customer onboarding',
    'Product training & adoption',
    'Employee onboarding',
    'Support deflection',
    'Partner / reseller enablement',
    'Something else'
];

export const UseCaseTitle = () => (
    <div>
        <h1 className="un-auth__q un-auth__q--sm">What will you use UserNurture for?</h1>
        <p className="un-auth__sub">Pick all that apply — this shapes your templates and dashboard.</p>
    </div>
);

const UseCase = ({ onChangeStep }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => getOnboardingData(state));
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const selected = data.useCases || [];

    const toggle = (option) => {
        const next = selected.includes(option)
            ? selected.filter((o) => o !== option)
            : selected.concat(option);
        dispatch(setOnboardingData({ useCases: next }));
    };

    const saveData = () => {
        setIsLoading(true);
        setError(null);
        http_put(API_ENDPOINTS.PUT_COMPANY, { use_cases: selected })
            .then(() => onChangeStep())
            .catch((err) => {
                setError(err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.');
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <div className="un-auth__pills">
                {OPTIONS.map((option) => (
                    <button
                        key={option}
                        type="button"
                        className={`un-auth__pill ${selected.includes(option) ? 'sel' : ''}`}
                        onClick={() => toggle(option)}
                    >
                        {option}
                    </button>
                ))}
            </div>
            {error && <p className="un-auth__err" role="alert">{error}</p>}
            <button className="un-auth__btn un-auth__btn--primary" onClick={saveData} disabled={selected.length === 0 || isLoading}>
                {isLoading ? 'Saving…' : 'Continue'}
            </button>
        </>
    );
};

export default UseCase;
